import React, { useState, useEffect, useCallback } from "react";
import UserSidbar from "../Layout/UserSidbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getCounsChatHistory } from "../../redux/action/CounsellorApi";
import Loader from "../Pages/Loader";

const Wallet = ({ isAuthenticated = false, user }) => {
  const [page, setPage] = useState(1);

  const {  totalPages, counsellorChatHistory, message, error, loading } = useSelector(
    state => state.Counsellor
  );

  const getStatusBadge = (status) => {
      const value = parseInt(status); // Ensure numeric comparison

  switch (value) {
    case 1:
      return <span className="badge bg-success">Completed</span>;
    case 2:
      return <span className="badge bg-danger">Missed</span>;
    default:
      return <span className="badge bg-secondary">Not Connected</span>;
  }
};

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const chatDetails = useCallback(() => {
    const postdata = {
      userId: localStorage.getItem("userId"),
      hash_token: localStorage.getItem("hashToken"),
      page: page,
      limit: 10,
    };

    dispatch(getCounsChatHistory(postdata));
  }, [dispatch, page]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    } else {
      chatDetails();
    }

    if (error) {
      toast.error(error);
      dispatch({ type: "clearError" });
    }

    if (message) {
      toast.success(message);
      dispatch({ type: "clearMessage" });
    }
  }, [navigate, dispatch, chatDetails, isAuthenticated, error, message]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  return (
    <>

      <section className="wallet_page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <UserSidbar user={user} />
            </div>
            <div className="col-lg-9 col-md-9 col-sm-6 col-xs-12">
              <div className="wallet_right">
                <div className="row charts_sec">
                  <div className="col-md-12 recharge_his">
                    <h5 className="">
                      Chat History <img src="./assets/images/recharge.svg" alt="" />
                    </h5>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {loading ? <Loader /> :
                    <>
                    <div className="recharge_history">
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover align-middle text-center">
                          <thead className="table-light">
                            <tr>
                              <th>Image</th>
                              <th>Name</th>
                              <th>Date</th>
                              <th>Total Minute</th>
                              <th>Total Call Amount</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {counsellorChatHistory && counsellorChatHistory.length > 0 ? (
                              counsellorChatHistory.map((paylist, index) => (
                                <tr key={index}>
                                  <td>
                                    <img
                                      src={paylist.pic ? paylist.pic : "./assets/images/profile.svg"}
                                      alt="user"
                                      className="rounded-circle"
                                      style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                    />
                                  </td>
                                  <td>{paylist.name}</td>
                                  <td>{paylist.start_time}</td>
                                  <td>{paylist.call_time}</td>
                                  <td>₹{paylist.total_call_amount}</td>
                                  <td>{getStatusBadge(paylist.status)}</td>

                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4">
                                  <h5 className="mt-3 mb-3">No call history found.</h5>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="recharge_all">
                        {totalPages > 1 && (
                          <div className="pagination-wrapper text-center mt-4">
                            <button
                              className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                              onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                              disabled={page === 1}
                            >
                              &laquo; Prev
                            </button>

                            <span className="pagination-page">Page {page} of {totalPages}</span>

                            <button
                              className={`pagination-btn ${page === totalPages ? "disabled" : ""}`}
                              onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                              disabled={page === totalPages}
                            >
                              Next &raquo;
                            </button>
                          </div>
                        )}
                      </div>


                    </div>
                     </>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Wallet;
